import type { LinksFunction } from '@remix-run/node';

import { useNavigate } from '@remix-run/react';

import {
  DbooButton,
  links as dbooButtonLinks,
} from '@/components/dboo/dboo-button/dboo-button';

import { SharedIllustration } from '@/components/shared/shared-illustration/shared-illustration';

import { DBOO_EDUCATION_START_FLOW } from '@/constants/dboo/paths';

import styles from './dboo-what-are-data-brokers.css?url';

export const links: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
  ...dbooButtonLinks(),
];

export const DbooWhatAreDataBrokers = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(DBOO_EDUCATION_START_FLOW);
  };

  return (
    <div className="container">
      <div className="dboo-what-are-data-brokers">
        <div className="dboo-what-are-data-brokers__wrapper">
          <SharedIllustration name="data-broker" />
          <h2 className="dboo-what-are-data-brokers__title">
            What are data brokers?
          </h2>
          <p className="dboo-what-are-data-brokers__description">
            Data brokers profit by collecting and sharing your data, exposing
            you to ads, scams, and identity theft. We help get you off their
            sites to protect your privacy.
          </p>
          <DbooButton variant="secondary" onClick={handleNavigate}>
            Learn about data brokers
          </DbooButton>
        </div>
      </div>
    </div>
  );
};
